import ShopTab from '../../../tabs/shop/ShopTab'

export default function ShopScreen() {
  return <ShopTab />
}
